var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.051,
    height: 18.38,
    viewBox: "0 0 20.051 18.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M24.051,20.874V17.532a.835.835,0,1,0-1.671,0v3.342a.835.835,0,0,1-.835.835H6.506a.835.835,0,0,1-.835-.835V17.532a.835.835,0,1,0-1.671,0v3.342A2.506,2.506,0,0,0,6.506,23.38H21.544a2.506,2.506,0,0,0,2.506-2.506Zm-5.33-4.361-4.177,3.342a.835.835,0,0,1-1.036,0L9.33,16.512a.835.835,0,0,1,1.036-1.3l2.824,2.256V5.835a.835.835,0,0,1,1.671,0V17.465l2.824-2.256a.835.835,0,1,1,1.036,1.3Z",
    transform: "translate(-4 -5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2f3dc8f243eeeca3b41d55472251205f.svg";
export { ForwardRef as ReactComponent };